import { render } from "./Heading.vue?vue&type=template&id=6da6765f"
const script = {}

import exportComponent from "/var/www/vhosts/byte-dev.it/carma.byte-dev.it/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__